import { FormField } from './form-field';

export class FormFieldRadio extends FormField<string> {
  controlType = 'radio';
  options: {label: string, value: string, checked: boolean}[] = [];
  defaultValue: string;

  constructor(options: {} = {}, defaultValue) {
    super(options);
    this.options = options['options'] || [];
    this.value = defaultValue;
  }
}
